import React, { useEffect, useState } from 'react'
import PrivacyNoticeView from './components/PrivacyNoticeView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const PrivacyNotice = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('privacy-notice', 'Change of Address', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language])

  return isError ? <Error /> : <PrivacyNoticeView setIsError={setIsError} />
}

export default withTranslation('common')(PrivacyNotice)
